__turbopack_context__.v({
  "button": "oiPmda_button",
  "shrink": "oiPmda_shrink",
  "title": "oiPmda_title",
});
